import type { AppState } from 'types/app';

export const selectProductNotify = (state: AppState) => state?.sharing?.productNotify;

export const selectProduct = (state: AppState) => selectProductNotify(state)?.product;
